// Medalchemy (Curaleaf)
export const MEDALCHEMY_STRAINS = [
  {
    id: "medalchemy-wedding-pop-triangle",
    name: "Wedding Pop Triangle",
    producer: "Medalchemy (Curaleaf)",
    country: "Portugalia",
    genetics: "Hybryda/Sativa",
    lineage: "Wedding Pop × Triangle Kush",
    thc: 24, cbd: 1.0,
    availability: "Wysoka", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Słodki", "Waniliowy"],
    description: "Hybryda/sativa dzięki połączeniu kariofilenu i limonenu daje efekt poprawiający nastrój i przeciwdepresyjny, powodując wzrost serotoniny i dopaminy, a dodatek linalolu i mircenu wzmaga jej działanie przeciwlękowe. Dodatkowo mircen zmniejsza napięcie mięśniowe, a w wyższych dawkach może dawać efekt sedacji, korzystnie wpływając na jakość snu.",
    terpenes: { kariofilen: 46, mircen: 10, linalol: 19, limonen: 25 },
    dominantTerpene: "Kariofilen", packaging: "10g",
    dateAdded: "2026-08-21"
  },
  {
    id: "medalchemy-zookies",
    name: "Zookies",
    producer: "Medalchemy (Curaleaf)",
    country: "Portugalia",
    genetics: "Hybryda/Indica",
    lineage: "Animal Cookies × Gorilla Glue #4",
    thc: 25, cbd: 1.0,
    availability: "Wysoka", effect: "Zrównoważone",
    aromas: ["Korzenny", "Ziołowy", "Orzechowy"],
    description: "Hybryda/indica od producenta Medalchemy może początkowo powodować pobudzenie i aktywizację, dzięki obecnemu w suszu limonenowi, który zwiększa poziom serotoniny i dopaminy, a ponadto działa gastroprotekcyjnie - tak jak dominujący w suszu kariofilen. Kariofilen ma silne właściwości przeciwzapalne i przeciwbólowe, synergistycznie do drugiego najbardziej obecnego w leku terpenu linalolu, a sam linalol, wraz z mircenem, po ustąpieniu początkowego pobudzenia będą działały uspokajająco i relaksująca oraz poprawiały jakość snu Pacjenta.",
    terpenes: { kariofilen: 46, linalol: 33, mircen: 5, limonen: 16 },
    dominantTerpene: "Kariofilen", packaging: "10g",
    dateAdded: "2026-08-21"
  }
];